import { useFormik } from 'formik'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

import ButtonCinestar from '../../../Buttons/ButtonCinestar/ButtonCinestar'
import Checkbox from '../../../Inputs/Checkbox/Checkbox'
import Money from '../../../Money/Money'
import Typography from '../../../Typography/Typography'

import { documentSlugs } from 'components/Modal/DocumentPopupWindow/slugs'
import './Payment.scss'

const Payment = ({ data, loading, onPayment, setSlug }) => {
    const intl = useIntl()
    const priceOnSite = data?.application_prices?.find((item) => item.application === 'Client')?.price
    const saveLabelValue = priceOnSite - data?.price

    const formik = useFormik({
        initialValues: {
            checkBox: false,
        },
        validationSchema: Yup.object({
            checkBox: Yup.boolean().oneOf([true], intl.formatMessage({ id: 'forms.register.checkBoxNotChecked' })),
        }),
        onSubmit: () => {
            onPayment()
            return null
        },
    })

    return (
        <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
            <div className={'basket-payment d-flex align-items-center justify-content-between'}>
                <div className="price-wrapper d-flex">
                    <Typography color={'basePrimary'} variant={'label'}>
                        {intl.formatMessage({ id: 'basket.totalPrice' })}
                    </Typography>
                    <Typography color={'basePrimary'} variant={'bodyBold'}>
                        <Money amount={data?.price} currency={data?.currency} />
                    </Typography>

                    {saveLabelValue ? (
                        <div className="saveMoney">
                            <Typography color={'basePrimary'} variant={'label'} className={'d-inline text-center'}>
                                {intl.formatMessage(
                                    { id: 'basket.moneySaved' },
                                    {
                                        price: `${saveLabelValue} ${data?.currency}`,
                                        span: (chunks) => (
                                            <Typography
                                                className={'d-inline saveMoneyValue'}
                                                color={'basePrimary'}
                                                variant={'bodyBold'}
                                            >
                                                {chunks}
                                            </Typography>
                                        ),
                                    }
                                )}
                            </Typography>
                        </div>
                    ) : null}
                </div>
                <div className="btns-wrapper d-flex align-items-center">
                    <Checkbox
                        name={'checkBox'}
                        id={'checkBox'}
                        color={'white'}
                        error={formik?.errors?.checkBox}
                        touched={formik?.touched?.checkBox}
                        {...formik.getFieldProps('checkBox')}
                        label={
                            <a
                                onClick={() => setSlug({ slug: documentSlugs.conditions })}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {intl.formatMessage(
                                    { id: 'forms.register.checkboxLabel' },
                                    { span: (chunks) => <span className="text-decoration-underline">{chunks}</span> }
                                )}
                            </a>
                        }
                        onBlur={formik?.handleBlur}
                        disabled={loading}
                        className={'d-none d-md-block py-2 my-1'}
                    />
                    <ButtonCinestar
                        variant={'primary-v1'}
                        disabled={loading}
                        className={'text-uppercase'}
                        type={'submit'}
                    >
                        {intl.formatMessage({ id: 'basket.paymentBtn' })}
                    </ButtonCinestar>
                </div>
            </div>
            <Checkbox
                name={'checkBox'}
                id={'checkBox'}
                color={'white'}
                error={formik?.errors?.checkBox}
                touched={formik?.touched?.checkBox}
                {...formik.getFieldProps('checkBox')}
                label={
                    <a onClick={() => setSlug({ slug: documentSlugs.conditions })} target="_blank" rel="noreferrer">
                        {intl.formatMessage(
                            { id: 'forms.register.checkboxLabel' },
                            { span: (chunks) => <span className="text-decoration-underline">{chunks}</span> }
                        )}
                    </a>
                }
                onBlur={formik?.handleBlur}
                disabled={loading}
                className={'d-md-none mt-2 mb-1 pb-2'}
            />
        </form>
    )
}

export default Payment
